// 模块级单例状态
let isRefreshing = false
let _showModalFn = null
const pendingCallbacks = []

// 由 ReAuthModal 组件在 onMounted 时注册
export function registerShowModal(fn) {
  _showModalFn = fn
}

// 由 request.js 调用，触发弹窗（只触发一次）
export function showReAuthModal() {
  if (!isRefreshing) {
    isRefreshing = true
    _showModalFn?.()
  }
}

// 由 request.js 的拦截器调用，将失败请求的回调存入队列
export function addPendingCallback(callback) {
  pendingCallbacks.push(callback)
}

// 登录成功后由 ReAuthModal 调用，依次重试所有挂起请求
export function onReAuthSuccess(token) {
  const cbs = [...pendingCallbacks]
  pendingCallbacks.length = 0
  isRefreshing = false
  cbs.forEach(cb => cb(token))
}

// 登录失败/放弃后调用（错误处理备用）
export function onReAuthFailed() {
  pendingCallbacks.forEach(cb => cb(''))
  pendingCallbacks.length = 0
  isRefreshing = false
}
